export default {
    view: "View More"
}